const getContainerNumbersFromPoDetail = (cad) => {
  if (cad.po_detail == null) return []
  return cad.po_detail.split(',').map(x => x.split(' — ')[3]).filter(x => x != '')
}

export {getContainerNumbersFromPoDetail}
